"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var react_router_dom_1 = require("react-router-dom");
var Main_1 = __importDefault(require("components/Layout/Main"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var fullServiceStats_1 = require("utils/hooks/fullServiceStats");
var single_1 = require("utils/selectors/single");
var ToolInStackView_1 = __importDefault(require("./ToolInStackView"));
var ToolView_1 = __importDefault(require("./ToolView"));
var SingleToolView = function () {
    var toolName = (0, react_router_dom_1.useParams)().toolName;
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [{ collection: 'services', where: ['slug', '==', toolName], storeAs: "serviceBySlug".concat(toolName) }]; });
    var selectServiceBySlug = react_1.default.useMemo(function () { return (0, single_1.makeSelectServiceBySlug)(toolName); }, [toolName]);
    var dealMeta = (0, react_redux_1.useSelector)(selectServiceBySlug);
    var myProfile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var _a = __read((0, fullServiceStats_1.useGetServiceStatWithExtras)(dealMeta === null || dealMeta === void 0 ? void 0 : dealMeta.id, !!(myProfile === null || myProfile === void 0 ? void 0 : myProfile.isAdmin)), 1), serviceStatWithExtras = _a[0];
    if ((dealMeta === null || dealMeta === void 0 ? void 0 : dealMeta.slug) !== toolName) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Hudled Deal", description: "Hudled Deal - ".concat(dealMeta === null || dealMeta === void 0 ? void 0 : dealMeta.name) }), (0, jsx_runtime_1.jsx)(Main_1.default, __assign({ hasSidebar: true }, { children: (0, jsx_runtime_1.jsx)(system_1.Box, __assign({ width: 1000, mx: "auto", mb: 2, display: "flex", justifyContent: (dealMeta === null || dealMeta === void 0 ? void 0 : dealMeta.deals) && !serviceStatWithExtras ? 'initial' : 'center' }, { children: serviceStatWithExtras
                        ? (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, sm: 8 }, { children: (0, jsx_runtime_1.jsx)(ToolInStackView_1.default, { toolStats: serviceStatWithExtras }) }))
                        : (0, jsx_runtime_1.jsx)(ToolView_1.default, { service: dealMeta }) })) }))] }));
};
exports.default = SingleToolView;
